import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {customProperties: true},
        themes: {
            light: {
                primary: '#1E2543', //Donker blauw VVS
                secondary: '#1E2543', //Donker blauw VVS
                accent: '#1E2543', //Donker blauw VVS
                background: '#BCDEF3', //Licht blauw
                navtext: '#1E2543', //Donker blauw VVS
                primarybackground: '#1E2543', //Donker blauw VVS
                accentDonker: '#1E2543', //Donker blauw VVS
            },
        },
    },
    breakpoint: {
        mobileBreakpoint: 'xs'
    }

});

// primary: '#1E2543', //Donker blauw VVS
//     secondary: '#FFFFFF', //Wit
//     accent: '#1E2543', //Donker oranje
//     background: "#BCDEF3", //Licht blauw
//     navtext: "#FFD990", //Licht oranje
//     primarybackground: "#F8E9B7", //Licht geel
//     accentDonker: '#E3A14E', //Donker oranje